import { render, staticRenderFns } from "./PublishedCheckbox.vue?vue&type=template&id=2a64025a&scoped=true&"
import script from "./PublishedCheckbox.vue?vue&type=script&lang=js&"
export * from "./PublishedCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./PublishedCheckbox.vue?vue&type=style&index=0&id=2a64025a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64025a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
